module.exports = __webpack_public_path__ + "static/media/dec-maintenance-small.295b278b.jpg";